import classNames from 'classnames';

import { VisualType, VisualVariant } from './enums';

const buttonClassesHelper = (className, type: VisualType, variant: VisualVariant): string =>
  classNames(`btn ${className || ''} btn__${type} btn--${variant}`);

export default buttonClassesHelper;
